import {createApp} from 'vue'
import DirectMessageThread from './DirectMessageThread'

const el = '.kb-component--direct-message-thread'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DirectMessageThreadDOM) => {
            const externalData = JSON.parse(DirectMessageThreadDOM.dataset.external)

            const props = {
                chatId: externalData?.chatId,
                userData: externalData?.userData
            }

            const component = createApp(DirectMessageThread, props).use(Store)
            component.mount(DirectMessageThreadDOM)
        })
    }
}